import { BaseApiProvider, IChildrenWithApiResponse } from 'src/v2-components/flights/shared/ApiProvider';
import { ApiProviderContext } from './Context';
import { ISavedFareListAllApiResponses } from './types';

export function SavedFareListApiProvider(props: IChildrenWithApiResponse<ISavedFareListAllApiResponses>) {
  return <BaseApiProvider ApiContext={ApiProviderContext} {...props} />;
}
